import { render, staticRenderFns } from "./gasClampPower.vue?vue&type=template&id=38e2b8c4&scoped=true"
import script from "./gasClampPower.vue?vue&type=script&lang=js"
export * from "./gasClampPower.vue?vue&type=script&lang=js"
import style0 from "./gasClampPower.vue?vue&type=style&index=0&id=38e2b8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2b8c4",
  null
  
)

export default component.exports